// Globals
import { FC } from 'react';

// Components
import { Tooltip } from '@/ui';
import { StyledContent, StyledTooltipContent } from './ProductSyncErrorSummaryStyles';

type TProductSyncErrorSummaryProps = {
  error?: string;
  status: string;
};

const ProductSyncErrorSummary: FC<TProductSyncErrorSummaryProps> = ({ error, status }) => {
  return (
    <Tooltip title={<StyledTooltipContent>{error}</StyledTooltipContent>}>
      <StyledContent>{status}</StyledContent>
    </Tooltip>
  );
};

export default ProductSyncErrorSummary;
